import React, { useRef } from "react";

import Grid from '@material-ui/core/Grid';
import LaunchIcon from '@material-ui/icons/Launch';

import Title from '@base/Title';
import Toast from '@base/Toast';
import Breadcrumbs from "@base/Breadcrumbs";
import ButtonPrimary from '@base/Button';

export const Digitacao = () => {
	const toastRef = useRef();

	const pageName = 'Digitação';
	const breadcrumbs = [];

	return (
		<>
			<Toast ref={toastRef} />
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Breadcrumbs links={breadcrumbs} active={pageName} />
				</Grid>
			</Grid>
			<Title>{pageName}</Title>

				<Grid container spacing={3} >
					<Grid item xs={12} >
						<ButtonPrimary
							onClick={() => window.open(process.env.REACT_APP_DIGITACAO_URL, "_blank")}
							name="Ir para o Sistema de Digitação"
							startIcon={<LaunchIcon />}
						/>
					</Grid>
				</Grid>
			
		</>
	);
}

export default Digitacao;
